import { render, staticRenderFns } from "./admin_orderList.vue?vue&type=template&id=465dc564&scoped=true"
import script from "./admin_orderList.vue?vue&type=script&lang=js"
export * from "./admin_orderList.vue?vue&type=script&lang=js"
import style0 from "./admin_orderList.vue?vue&type=style&index=0&id=465dc564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465dc564",
  null
  
)

export default component.exports